/*
 * @Author: your name
 * @Date: 2021-03-15 20:03:34
 * @LastEditTime: 2021-08-04 18:07:51
 * @LastEditors: yang chenglin
 * @Description: In User Settings Edit
 * @FilePath: \common\src\components\sms\smsTemplate\index.tsx
 */
import React from 'react';
import styles from './index.module.scss';
import SystemModel from './components/SystemModel';

const smsTemplate = (props) => {
  const { systemSelect, modelTypeCode} = props;
  return (
    <div>
      {/* 短信模板选择弹窗 */}
      <div className={`${styles.peopledialogContent} tab-content`} style={{ maxHeight: (window.screen.height) * 0.8 - 180, overflowY: 'auto' }}>
        <SystemModel
          systemSelect={(tem) => {
            systemSelect(tem);
          }}
          modelTypeCode={modelTypeCode}
        />
        {/* <div className="choose-sms-template-dialog setTabsStyle">
           <Tab shape="pure" style={{paddingLeft:'10px',paddingRight:'10px'}}>
             <Tab.Item title="自定义模板" key="1" style={{width:"120px",textAlign:"center"}}>
               <DiyMedel diySelect={(tem)=>{props.diySelect(tem)}}/>
             </Tab.Item>
             <Tab.Item title="系统模板" key="2" style={{width:"120px",textAlign:"center"}}>
               <SystemModel systemSelect={(tem)=>{props.systemSelect(tem)}}/>
             </Tab.Item>
           </Tab>
         </div> */}
      </div>
    </div>
  );
};

export default smsTemplate;
